module.exports = __webpack_public_path__ + "static/img/item-6-4-big.8b31dab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-6-4-big.png
// module id = JZ5y
// module chunks = 2